const trueFalse = [
  { key: 'y', text: 'Yes', value: true },
  { key: 'n', text: 'No', value: false }
];

export default trueFalse;